//

import { Erc20Wei } from '@shared/conversions'
import { PoolOverviewCTO, PoolSummaryDTO, PoolAccountCTO } from '@shared/sharedTypes'

export const buildCompletePoolSummary = (poolOverviewCTO: PoolOverviewCTO): PoolSummaryDTO => {
  const indicativeApr = Number(poolOverviewCTO?.activeLoanState?.indicativeApr)
  const finalizedApr = Number(poolOverviewCTO?.activeLoanState?.finalizedApr)
  const tenor: number = poolOverviewCTO?.activeLoanState?.durationDays

  const matureEthDate =
    poolOverviewCTO?.activeLoanState?.maturingTimestamp === 0
      ? poolOverviewCTO.requestedLoanState.maturingTimestamp
      : poolOverviewCTO?.activeLoanState?.maturingTimestamp

  const totalRequestedAssets = poolOverviewCTO?.totalRequestedAssets

  return {
    indicativeApr,
    finalizedApr,
    tenor,
    matureEthDate,
    totalRequestedAssets,
  }
}

export const buildLenderPoolSummary = (
  poolOverviewCTO: PoolOverviewCTO,
  poolAccountCTO: PoolAccountCTO | undefined
): PoolSummaryDTO => {
  const indicativeApr = Number(poolOverviewCTO?.activeLoanState?.indicativeApr)
  const finalizedApr = Number(poolOverviewCTO?.activeLoanState?.finalizedApr)
  const tenor: number = poolOverviewCTO?.activeLoanState?.durationDays

  const matureEthDate =
    poolOverviewCTO?.activeLoanState?.maturingTimestamp === 0
      ? poolOverviewCTO.requestedLoanState.maturingTimestamp
      : poolOverviewCTO?.activeLoanState?.maturingTimestamp

  const totalRequestedAssets = Erc20Wei(
    poolAccountCTO
      ? (
          Number(poolAccountCTO.requestedAssetsOf) +
          Number(poolAccountCTO.earlyRequestedAssetsOf) +
          Number(poolAccountCTO.withdrawableAssetsOf) +
          Number(poolAccountCTO.earlyAcceptedAssetsOf)
        ).toString()
      : '0'
  )

  return {
    indicativeApr,
    finalizedApr,
    tenor,
    matureEthDate,
    totalRequestedAssets,
  }
}
